import { Button } from "@similarweb/ui-components";
import categoryService from "app/common/services/categoryService";
import { swSettings } from "app/common/services/swSettings";
import LocationService from "pro-features/components/Modals/src/UnlockModal/LocationService";
import { translate } from "app/filters/i18nFilter";
import type { FC } from "react";
import { useState } from "react";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { openDefaultHooksModal } from "app/services/ModalService";
import { allTrackers } from "app/services/track/track";
import styled from "styled-components";
import { CustomIndustryButtonNotification } from "./CustomIndustryButtonNotification";
import { PlainTooltip } from "@similarweb/ui-components";
import useLocalStorage from "app/custom-hooks/useLocalStorage";
import { useExceededLimitation } from "app/components/metering/UseLimitation";
import {
    isIndustryAnalysisLimitationExceeded,
    showIndustryAnalysisMeteringHook,
} from "pro-features/pages/module start page/src/industry analysis/utils/metering/IndustryAnalysisMetering";

const INTERNAL_SOURCE_PARAM_VALUE = "Compare more";
const CREATE_CUSTOM_INDUSTRY_NOTIFICATION_KEY = "viewed-website-querybar-create-custom-industry-notification";

const StyledCtaButton = styled(Button)`
    text-wrap: nowrap;
`;

export const CreateCustomIndustryButton: FC = () => {
    const [hasSeenPromotionalTooltip, setHasSeenPromotionalTooltip] = useLocalStorage(
        CREATE_CUSTOM_INDUSTRY_NOTIFICATION_KEY,
    );
    const [isNotificationVisible, setIsNotificationVisible] = useState(!JSON.parse(hasSeenPromotionalTooltip));

    const isLimitationExceeded = useExceededLimitation(isIndustryAnalysisLimitationExceeded);

    const onCloseNotificationClick = () => {
        setIsNotificationVisible(false);
        setHasSeenPromotionalTooltip(true.toString());
    };

    const onCreateCustomIndustryButtonClick = () => {
        if (isLimitationExceeded) {
            showIndustryAnalysisMeteringHook();
            return;
        }

        const { country, key } = proNavigator.getParams();
        if (
            swSettings.components.Home.resources.IsCCAllowed &&
            categoryService.hasAdvancedCustomIndustriesPermission()
        ) {
            allTrackers.dispatchTrackEvent("Button", "click", "Compare more");
            proNavigator.go("market_research_builder", {
                initialDomains: key,
                initialCountry: country,
                internalSource: INTERNAL_SOURCE_PARAM_VALUE,
            });
        } else {
            const location = `${LocationService.getCurrentLocationTracking()}/New Category`;
            openDefaultHooksModal("IndustryCustomCategories", location);
        }
    };

    return (
        <CustomIndustryButtonNotification
            isVisible={isNotificationVisible}
            onCloseNotificationClick={onCloseNotificationClick}
        >
            <PlainTooltip
                tooltipContent={translate("querybar.websites.createCustomCategory.button.tooltip")}
                enabled={!isNotificationVisible}
                placement="bottom"
                appendTo="body"
            >
                <div>
                    <StyledCtaButton
                        type="outlined"
                        onClick={onCreateCustomIndustryButtonClick}
                    >
                        {translate("querybar.websites.createCustomCategory.button")}
                    </StyledCtaButton>
                </div>
            </PlainTooltip>
        </CustomIndustryButtonNotification>
    );
};
